__turbopack_context__.v({
  "base-icon-lose": "sport-bet-row-module-sass-module__OhbaWa__base-icon-lose",
  "base-icon-losevoid": "sport-bet-row-module-sass-module__OhbaWa__base-icon-losevoid",
  "base-icon-loss": "sport-bet-row-module-sass-module__OhbaWa__base-icon-loss",
  "base-icon-win": "sport-bet-row-module-sass-module__OhbaWa__base-icon-win",
  "base-icon-winvoid": "sport-bet-row-module-sass-module__OhbaWa__base-icon-winvoid",
  "bet": "sport-bet-row-module-sass-module__OhbaWa__bet",
  "betExpress": "sport-bet-row-module-sass-module__OhbaWa__betExpress",
  "bonus": "sport-bet-row-module-sass-module__OhbaWa__bonus",
  "details": "sport-bet-row-module-sass-module__OhbaWa__details",
  "detailsBtn": "sport-bet-row-module-sass-module__OhbaWa__detailsBtn",
  "detailsBtnVertical": "sport-bet-row-module-sass-module__OhbaWa__detailsBtnVertical",
  "game": "sport-bet-row-module-sass-module__OhbaWa__game",
  "icon": "sport-bet-row-module-sass-module__OhbaWa__icon",
  "info": "sport-bet-row-module-sass-module__OhbaWa__info",
  "label": "sport-bet-row-module-sass-module__OhbaWa__label",
  "odds": "sport-bet-row-module-sass-module__OhbaWa__odds",
  "opened": "sport-bet-row-module-sass-module__OhbaWa__opened",
  "return": "sport-bet-row-module-sass-module__OhbaWa__return",
  "totalBets": "sport-bet-row-module-sass-module__OhbaWa__totalBets",
});
